import { render, staticRenderFns } from "./google2.vue?vue&type=template&id=1d050299&scoped=true"
import script from "./google2.vue?vue&type=script&lang=js"
export * from "./google2.vue?vue&type=script&lang=js"
import style0 from "./google2.vue?vue&type=style&index=0&id=1d050299&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d050299",
  null
  
)

export default component.exports